import React, { useState } from "react";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import CustomInput from "../../Component/BasicComponents/CustomInput";
import ReusableDropdown from "../../Component/BasicComponents/Dropdowns/RouteDropdown";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import AddTerritoryModal from "./Components/AddTerritoryModal";
import AddOnBoardWindow from "./Components/AddOnBoardWindow";
import { useNavigate } from "react-router-dom";
// import AnnouncementModal from "./components/AnnouncementModal";

type Props = {};

function MyTerritories({}: Props) {
  const navigate = useNavigate();

  const [isOpenModal, setIsModalOpen] = useState(false);
  const [modalStatus, setModalStatus] = useState("");
  const [createOnBoardModalOpen, setCreateOnBoardModalOpen] = useState(false);

  const toggle = () => {
    setIsModalOpen(!isOpenModal);
  };

  const handleAddTerritory = () => {
    setModalStatus("Add");
    setIsModalOpen(true);
  };

  const handleCreateOnBoardWindow = () => {
    setModalStatus("Create Onboard");
    setCreateOnBoardModalOpen(true);
  };

  const handleEditTerritories = () => {
    setModalStatus("Edit");
    setIsModalOpen(true);
    console.log("EDIT TERRITORIES");
  };
  const handleViewTerritories = () => {
    // setModalStatus("View");
    // setIsModalOpen(true);
    // console.log("VIEW TERRITORIES");
    navigate("/myterritorytown")
  };
  const handleSubmit = () => {
    // setModalStatus("Add");
    // setIsModalOpen(true);
    alert("Submit!");
    setIsModalOpen(!isOpenModal);
  };

  const handleSubmitOnBoardWindow = () => {
    console.log("Submit On Boarding!");
    setCreateOnBoardModalOpen(!createOnBoardModalOpen);
  };

  const toggleOnBoardWindow = () => {
    setCreateOnBoardModalOpen(!createOnBoardModalOpen);
  };

  return (
    <div className="p-2">
      <PageHeader
        title="My Territories"
        buttons={[
          {
            label: "+ Add Territory",
            onClick: () => handleAddTerritory(),
            color: "#43B9B2",
          },
          {
            label: "+ Create OnBoard Window",
            onClick: () => handleCreateOnBoardWindow(),
            color: "#43B9B2",
          },
          {
            label: "Excel",
            onClick: () => alert("Download Excel"),
            color: "#43B9B2",
          },
          {
            label: "CSV",
            onClick: () => alert("Download CSV"),
            color: "#43B9B2",
          },
        ]}
      />

      {/* Table with Filters */}
      <BasicDataTable
        Title="Territories"
        data={announcementData || []}
        columns={myTerritoriesColumns(
          handleEditTerritories,
          handleViewTerritories
        )}
      />

      <RouteModal
        size="md"
        toggle={toggle}
        isOpen={isOpenModal}
        title={modalStatus === "Add" ? "Add Territory" : "Edit Territory"}
        content={
          <>
            <AddTerritoryModal
              handleSubmit={handleSubmit}
              toggle={toggle}
              modalStatus={modalStatus}
            />
          </>
        }
      />
      <RouteModal
        size="md"
        toggle={toggleOnBoardWindow}
        isOpen={createOnBoardModalOpen}
        title="Add On Board Window"
        content={
          <>
            <AddOnBoardWindow
              handleSubmitOnBoard={handleSubmitOnBoardWindow}
              toggle={toggleOnBoardWindow}
            />
          </>
        }
      />
    </div>
  );
}

export default MyTerritories;

const myTerritoriesColumns = (
  handleEditTerritories: (row: any) => void,
  handleViewTerritories: (row: any) => void
) => [
  {
    name: "Employee Name",
    selector: (row: { employeename: string }) =>
      row.employeename ? row.employeename : "-",
    sortable: true,
    // width: "180px",
  },
  {
    name: "Designation",
    selector: (row: { designation: string }) => row.designation ?? "-",
    sortable: true,
    // width: "180px",
  },
  {
    name: "Head Quarter Location",
    selector: (row: { HQL: string }) => row.HQL ?? "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Created",
    selector: (row: { created: string }) => row.created || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Submitted",
    selector: (row: { submitted: string }) => row.submitted || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Approved",
    selector: (row: { approved: string }) => row.approved || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Rejected",
    selector: (row: { rejected: string }) => row.rejected || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Processed",
    selector: (row: { processed: string }) => row.processed || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Actions",
    width: "200px",
    cell: (row: any) => (
      <>
        <button
          onClick={() => handleEditTerritories(row)}
          className="btn btn-primary"
          style={{ borderRadius: "20px", padding: "5px", width: "80px" }}
        >
          Edit
        </button>
        <button
          onClick={() => handleViewTerritories(row)}
          className="btn btn-primary"
          style={{
            borderRadius: "20px",
            padding: "5px",
            marginLeft: "12px",
            width: "80px",
          }}
        >
          View
        </button>
      </>
    ),
  },
];

const announcementData = [
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    HQL: "Test Sample",
    created: "0",
    submitted: "0",
    approved: "0",
    rejected: "0",
    processed: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    HQL: "Test Sample",
    created: "0",
    submitted: "0",
    approved: "0",
    rejected: "0",
    processed: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    HQL: "Test Sample",
    created: "0",
    submitted: "0",
    approved: "0",
    rejected: "0",
    processed: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    HQL: "Test Sample",
    created: "0",
    submitted: "0",
    approved: "0",
    rejected: "0",
    processed: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    HQL: "Test Sample",
    created: "0",
    submitted: "0",
    approved: "0",
    rejected: "0",
    processed: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    HQL: "Test Sample",
    created: "0",
    submitted: "0",
    approved: "0",
    rejected: "0",
    processed: "0",
  },
];
